export default function IconEyer() {
  return (
    <svg
      id="icon_eye"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Caminho_4307"
        data-name="Caminho 4307"
        d="M0,0H24V24H0Z"
        fill="none"
      />
      <path
        id="Caminho_4308"
        data-name="Caminho 4308"
        d="M12,3a11,11,0,0,1,10.819,9A11,11,0,0,1,1.181,12,11,11,0,0,1,12,3Zm0,16a9,9,0,0,0,8.777-7A9,9,0,0,0,3.223,12,9.005,9.005,0,0,0,12,19Zm0-2.5A4.5,4.5,0,1,1,16.5,12,4.5,4.5,0,0,1,12,16.5Zm0-2A2.5,2.5,0,1,0,9.5,12,2.5,2.5,0,0,0,12,14.5Z"
        fill="#e4e4e4"
      />
    </svg>
  );
}
